import React, { useState, useEffect } from "react";

import Form from "react-bootstrap/Form";


const WeekDate = (props) => {

   const [weekDateText, setWeekDateText] = useState(props.initialText || "Week no. / start date - end date")

   useEffect(() => {
      props.updateComponentHTML(props.id, 
         `<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-1" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #ffffff;" width="100%">
         <tbody>
             <tr>
                 <td>
                     <table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; border-radius: 0; color: #93A7B4; background-color: #212859; width: 600px;" width="600">
                         <tbody>
                             <tr>
                                 <td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; padding-top: 5px; padding-bottom: 5px; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="100%">
                                     <table border="0" cellpadding="0" cellspacing="0" class="paragraph_block block-1" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
                                         <tr>
                                             <td class="pad">
                                                 <div style="color:#ffffff;direction:ltr;font-family:Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif;font-size:14px;font-weight:400;letter-spacing:0px;line-height:120%;text-align:center;mso-line-height-alt:16.8px;">
                                                     <p style="margin: 0;">${weekDateText}</p>
                                                 </div>
                                             </td>
                                         </tr>
                                     </table>
                                 </td>
                             </tr>
                         </tbody>
                     </table>
                 </td>
             </tr>
         </tbody>
     </table>`)
   }, [])

   useEffect(() => {
      props.updateComponentHTML(props.id,
         `<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-1" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #ffffff;" width="100%">
         <tbody>
             <tr>
                 <td>
                     <table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; border-radius: 0; color: #93A7B4; background-color: #212859; width: 600px;" width="600">
                         <tbody>
                             <tr>
                                 <td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; padding-top: 3px; padding-bottom: 3px; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="100%">
                                     <table border="0" cellpadding="0" cellspacing="0" class="paragraph_block block-1" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; word-break: break-word;" width="100%">
                                         <tr>
                                             <td class="pad">
                                                 <div style="color:#ffffff;direction:ltr;font-family:Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif;font-size:12px;font-weight:400;letter-spacing:0px;line-height:120%;text-align:center;mso-line-height-alt:16.8px;">
                                                     <p style="margin: 0;">${weekDateText}</p>
                                                 </div>
                                             </td>
                                         </tr>
                                     </table>
                                 </td>
                             </tr>
                         </tbody>
                     </table>
                 </td>
             </tr>
         </tbody>
     </table>`)
   }, [weekDateText])

   return (
      <>
      <Form.Group controlId="exampleForm.ControlSelect1">
         <Form.Label>Change WeekDate Text</Form.Label>
         <Form.Control onChange={(event) => setWeekDateText(event.target.value)} value={weekDateText} />

      </Form.Group>
      </>
   )
}

export default WeekDate;